export const IS_TEST_MODE = typeof jest !== 'undefined';

export const COMMON_FIELDS = {
	id: 'id',
	version: 'version',
	modifiedTime: 'modifiedTime',
	createdTime: 'createdTime'
};

export const USERS_FIELDS = {
	...COMMON_FIELDS,
	displayName: 'displayName',
	email: 'email',
	phoneNumber: 'phoneNumber',
	logoutTime: 'logoutTime',
	status: 'status',
	externalIDs: 'externalIDs',
	tenants: 'tenants',
	roles: 'roles'
};

export const TENANTS_FIELDS = {
	...COMMON_FIELDS,
	name: 'name',
	selfProvisioningDomains: 'selfProvisioningDomains',
	status: 'status'
};

export const FLOWS_FIELDS = {
	...COMMON_FIELDS,
	name: 'name',
	description: 'description',
	disabled: 'disabled'
};

export const ACCESS_KEYS_FIELDS = {
	...COMMON_FIELDS,
	project: 'project',
	tenants: 'tenants',
	roles: 'roles',
	name: 'name',
	hash: 'hash',
	expireTime: 'expireTime',
	status: 'status',
	createdBy: 'createdBy',
	permittedProjects: 'permittedProjects'
};

export const PERMISSIONS_FIELDS = {
	...COMMON_FIELDS,
	name: 'name',
	description: 'description',
	systemDefault: 'systemDefault'
};

export const ROLES_FIELDS = {
	...COMMON_FIELDS,
	name: 'name',
	description: 'description',
	permissions: 'permissions',
	systemDefault: 'systemDefault'
};

export const AUDITS_FIELDS = {
	userId: 'userID',
	externalIDs: 'externalIDs',
	tenants: 'tenants',
	occurred: 'occurred',
	action: 'action',
	device: 'device',
	method: 'method',
	geo: 'geo',
	remoteAddress: 'remoteAddress',
	data: 'data'
};
